import { Component, Input, OnInit } from "@angular/core";
import { TimezoneService } from 'src/app/services/timezone';
@Component({
  selector: "app-transaction-detail-body-shared",
  templateUrl: "./transaction-detail-body-shared.component.html",
  styleUrls: ["./transaction-detail-body-shared.component.scss"],
})
export class TransactionDetailBodySharedComponent implements OnInit {
  @Input() paymentReceipt: any;
  @Input() receiptModal: Boolean;
  constructor(
    private timezoneService: TimezoneService,
  ) {}

  time= "";

  ngOnInit(): void {
    this.time = this.timezoneService.get().unix(this.paymentReceipt.createdAt).format("h:mm A");
  }


  convertDate(timeStamp: number) {
    if (timeStamp) {
      return this.timezoneService
        .get()(timeStamp * 1000)
        .format("MMM DD, YYYY");
    } else {
      return "";
    }
  }
}
